import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { TransmissionTypes } from "@/types";

export interface TransmissionManualState {
  result: TransmissionTypes.ManualClaimRawResponseData;
}

const DEFAULT_TRANSMISSION_MANUAL_STATE: TransmissionManualState = {
  result: {
    transaction_response_status: "",
  },
};

export default (state: TransmissionManualState = DEFAULT_TRANSMISSION_MANUAL_STATE, action: Action): {} => {
  if (action.type === ActionTypes.TRANSMISSION_MANUAL_RESULT) {
    return {
      result: action.payload,
    };
  } else {
    return state;
  }
};
